import styled from "styled-components";

import { PrimaryText } from "@/components/Typography/Styled";

export const StyledSACollapseWrapper = styled.div`
    position: relative;
    width: 100%;
    z-index: 4;
    padding: 16px;
    display: flex;
    justify-content: center;
    background-color: ${({ theme }) => theme.secondaryBackgroundColor};
`;

export const StyledTotalSum = styled.div`
    width: 100%;
    z-index: 5;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border: none;
    padding: 10px 16px;
    border-radius: 8px;
    background-color: ${(props) => props.theme.darkBlue};
`;

export const StyledTotalSumValue = styled(PrimaryText)`
    font-weight: 500;
    font-size: 14px;
    line-height: 120%;
    letter-spacing: 0%;

    color: ${(props) => props.theme.lightBlue} !important;
`;
